<template>
  <header class="menu-wrapper-container">
    <div class="logo-container">
      <logo/>
    </div>
    <div class="right-container">
      <main-title>
        {{ me?.email || 'admin@admin.admin' }}
      </main-title>
      <div class="avatar-container"></div>
    </div>
  </header>
</template>

<script>
import logo from '@/assets/logo/logo.svg?inline'
import MainTitle from "@/components/shared/text/MainTitle.vue";
export default {
  name: "HeaderMenu",
  components: {MainTitle, logo}
}
</script>

<style scoped lang="scss">
  .menu-wrapper-container {
    z-index: 998;
    position: fixed;
    height: fit-content;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 24px 32px;
    background: var(--color-dark-green);

    @media(max-width: 769px) {
      padding: 16px;
    }

    .logo-container {
      display: flex;
      align-items: center;
      justify-content: center;
      //min-width: 109px;
      //max-width: 109px;
      height: 20px;

      @media(max-width: 769px) {
        min-width: 80px;
        max-width: 80px;
        height: 15px;
      }
    }

    .right-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      column-gap: 24px;

      @media(max-width: 769px) {
        column-gap: 16px;
      }

      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: var(--color-grey);
      }
    }
  }
</style>